import { Container, Typography } from "@mui/material";
import React from "react";
import lightTheme from "../theme";
import ConsultationModal from "./ConsultationModal";

export default function Header({ requestSubmitted, setRequestSubmitted }) {
  return (
    <Container
      maxWidth="100vw"
      disableGutters
      sx={{
        backgroundImage:
          'url("https://edrusslaw-wziller.s3.us-east-2.amazonaws.com/pillars1.jpg")',
        height: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Container
        maxWidth="100vw"
        disableGutters
        sx={{
          backgroundColor: "rgba(255,255,255,0.55)",
          height: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "10px",
        }}
      >
        <Container sx={{ padding: "60px 0px" }}>
          <Typography
            align="center"
            variant="h1"
            sx={{
              color: lightTheme.palette.titleColor.main,
              fontWeight: "550",
            }}
          >
            Edward Russell
          </Typography>
          <Container sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>

              <img alt="captain's bars" src="https://edrusslaw-wziller.s3.us-east-2.amazonaws.com/captain's-bars-trans-bg.png" width="30px" height="auto" aspectRatio="inherit"></img>
              <Typography
                align="center"
                variant="h4"
                sx={{ color: lightTheme.palette.titleColor.main, margin:"10px" }}
              >
                The Law Captain
              </Typography>
              <img alt="captain's bars" src="https://edrusslaw-wziller.s3.us-east-2.amazonaws.com/captain's-bars-trans-bg.png" width="30px" height="auto" aspectRatio="inherit"></img>
          </Container>
          <Typography
            align="center"
            variant="h3"
            sx={{ color: lightTheme.palette.titleColor.main }}
          >
            Attorney and Counselor at Law
          </Typography>
        </Container>
        <ConsultationModal
          requestSubmitted={requestSubmitted}
          setRequestSubmitted={setRequestSubmitted}
        />
      </Container>
    </Container>
  );
}
